<div class="grid_container" formWithErrors #form=formWithErrors [formGroup]="tacheForm">
  <app-form-field label="Titre" [control]="getControl('titre')" [mobileSize]="12" required>
    <input formControlName="titre" class="form_input" type="text" #inputFocus/>
  </app-form-field>
  <app-form-field label="Description" [control]="getControl('description')" [mobileSize]="12">
    <textarea formControlName="description" class="form_input" type="text"></textarea>
  </app-form-field>

  <div class="date-hour__custom-container">
    <app-form-field label="Date" [control]="getControl('date')">
      <ejs-datepicker formControlName="date" format='dd-MM-yyyy' name="date">
      </ejs-datepicker>
    </app-form-field>
    @if (hasDate() && !showDetailHeures) {
      <app-form-field label="" >
        <div class="checkboxes is-label">
          <input type="checkbox" id="date-time" (click)="isChecked($event)">
          <label for="date-time"><span>Préciser les heures</span></label>
        </div>
      </app-form-field>
    }
    @if (hasDate() && showDetailHeures) {
      <app-form-field [control]="getControl('heureDebut') && getControl('heureFin')">
        <label for="">
          <span class="form_label is-required">Préciser les heures</span>
        </label>
        <div class="checkboxes">
          <input type="checkbox" id="date-time" checked (click)="isChecked($event)">
          <label for="date-time" class="is-error"></label>
          @if (showDetailHeures) {
            <div class="input-date">
              <input formControlName='heureDebut' class="form_input" id="heure_debut" type="time">
              <input formControlName='heureFin' class="form_input" id="heure_fin" type="time" required/>
            </div>
          }
        </div>
      </app-form-field>
    }
  </div>

  <app-form-field required label="Etat" [control]="getControl('etat')" [mobileSize]="12">
    <select class="select"  formControlName="etat" required>
      @for (etat of etats; track etat) {
        <option [ngValue]="etat">{{getLibelleEtat(etat)}}</option>
      }
    </select>
  </app-form-field>


  @if (listeFixeCategoriesTache?.length>1) {
    <app-form-field label="Catégorie" [control]="getControl('idCategorie')" [mobileSize]="12">
      <select class="form_select" formControlName="idCategorie" name="categorie">
        @for (valeur of listeFixeCategoriesTache; track valeur) {
          <option [ngValue]="valeur.id">
            {{valeur.libelle}}
          </option>
        }
      </select>
    </app-form-field>
  }
  <app-form-field>
    <app-edit-liens-taches formControlName="liens"></app-edit-liens-taches>
  </app-form-field>
</div>

@if (tacheExistante; as tache) {
  <div class="others">
    @if (tache.dateCreation) {
      <div class="createur">
        Créé le {{tache.dateCreation | date:'dd/MM/yyyy à  HH:mm'}}
        <div class="infos">
          @if (createur) {
            <i class="icon icon-cog" aria-hidden="true"></i>
            <div>{{createur}}</div>
          }
        </div>
      </div>
    }
    @if (tache.dateModification) {
      <div class="modificateur">
        <span>Modifié le {{tache.dateModification | date:'dd/MM/yyyy à  HH:mm'}}</span>
        <div class="infos">
          @if (modificateur) {
            <i class="icon icon-user1" aria-hidden="true"></i>
            <div>{{modificateur}}</div>
          }
        </div>
      </div>
    }
  </div>
}

<div class="actions">
  <button (click)="annuler()" class="button-grey-icon">
    <i class="icon icon-arrow-left"></i>
  </button>
  <button (click)="form.showErrors(); enregistrer()" class="button-base" >
    <i class="icon icon-validate"></i>
    <span class="button-main_text">
      {{getValidationButtonCaption()}}
    </span>
  </button>
</div>
